import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { Heading2 } from "../../../../components/FormCommons"

const RegulaminIndex = () => {
  const { i18n, t } = useTranslation()
  const language = i18n.language

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768)
    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  const pdfFile = language === "en" ? "/regulations.pdf" : "/regulamin.pdf"
  // #zoom=page-width makes built-in PDF viewer fit the text to the frame width
  const pdfSrc = `${pdfFile}#zoom=page-width`

  return (
    <section
      style={{
        display: "flex",
        flexDirection: "column",
        padding: isMobile ? "12px 16px" : "24px 32px",
        boxSizing: "border-box",
        minHeight: "100vh",
      }}
    >
      {/* Header row */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          marginBottom: "16px",
        }}
      >
        <Heading2 sx={{ margin: 0 }}>
          {t("Regulations.regulations", "Regulamin")}
        </Heading2>

        <a
          href={pdfFile}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 18px",
            borderRadius: "8px",
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: 600,
            fontSize: "14px",
            textDecoration: "none",
            whiteSpace: "nowrap",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          }}
        >
          {/* external link icon */}
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
          {t("Regulations.open_in_new_tab", "Otwórz w nowej karcie")}
        </a>
      </div>

      {isMobile ? (
        /* ── Mobile ── */
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            padding: "32px 16px",
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            backgroundColor: "#fafafa",
            textAlign: "center",
          }}
        >
          {/* PDF icon */}
          <svg
            width="56"
            height="56"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#d32f2f"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="9" y1="13" x2="15" y2="13" />
            <line x1="9" y1="17" x2="12" y2="17" />
          </svg>

          <p
            style={{
              margin: 0,
              fontSize: "15px",
              color: "#555",
              lineHeight: "1.6",
              maxWidth: "320px",
            }}
          >
            {t(
              "Regulations.mobile_pdf_info",
              "Regulamin dostępny jest jako dokument PDF. Dotknij przycisku, aby otworzyć go w czytelnym widoku."
            )}
          </p>

          <a
            href={pdfFile}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "12px 28px",
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              color: "#fff",
              fontWeight: 700,
              fontSize: "16px",
              textDecoration: "none",
              boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
            }}
          >
            {t("Regulations.read_regulations", "Przeczytaj regulamin")}
          </a>
        </div>
      ) : (
        /* ── Desktop / Tablet ── */
        <div
          style={{
            flex: 1,
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            overflow: "hidden",
            minHeight: "80vh",
          }}
        >
          <iframe
            src={pdfSrc}
            title={t("Regulations.regulations", "Regulamin")}
            width="100%"
            height="100%"
            style={{
              display: "block",
              border: "none",
              minHeight: "80vh",
            }}
          />
        </div>
      )}
    </section>
  )
}

export default RegulaminIndex
